import DynamicText, { getDynamicText } from "./common/DynamicText";
import Accordion from "./common/accordion/Accordion";
import usePensionProductInfo from "../hooks/usePensionProductInfo";
import {
  LoadingSpinner,
  Paragraph,
  TextContainer,
  useMatomo,
} from "frno-react";
import useTextStore from "../state/TextStore";

type IntroProps = {
  pensionType: string;
};

export default function Intro({ pensionType }: IntroProps) {
  const { getTextByKey } = useTextStore();
  const { trackEvent } = useMatomo();
  const { isLoading, data } = usePensionProductInfo(pensionType);

  function parsePensionType(pensionType: string) {
    return pensionType.replace(/[\s()]+/g, "");
  }

  return (
    <div>
      <h2 className="fs-3">{pensionType}</h2>
      <TextContainer>
        <Paragraph className="mt-4">
          <DynamicText
            textKey={`page.intro.ingress.${parsePensionType(
              pensionType.toLowerCase(),
            )}`}
          />
        </Paragraph>
      </TextContainer>

      {!isLoading && data ? (
        <Accordion
          header={
            <DynamicText
              textKey="page.intro.accordion.header"
              replaceComponent={getTextByKey(
                `page.intro.accordion.title.${parsePensionType(
                  pensionType.toLowerCase(),
                )}`,
              )}
            />
          }
          expandedContent={data}
          onClick={(expanded) => {
            if (expanded) {
              trackEvent({
                category: "Pensjon",
                action: `Pensjon: Utvidelse - ${getDynamicText(
                  getTextByKey("page.intro.accordion.header"),
                  pensionType.toLowerCase(),
                )}`,
              });
            }
          }}
        />
      ) : (
        <LoadingSpinner />
      )}
    </div>
  );
}
